export default "__VITE_ASSET__pSsgSTxu__";